var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_98",
    "data-name": "Groupe 98",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.234,
    height: 30.235,
    viewBox: "0 0 22 22",
    className: "main-navbar_logo-question",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_214",
    "data-name": "Trac\\xE9 214",
    d: "M37.023,28.985a8.854,8.854,0,0,0-8.357-7.047,8.832,8.832,0,0,0-8.356,7.047,2.41,2.41,0,0,0-2.122,2.836,2.435,2.435,0,0,0-1.044,1.88c0,1.733,1.921,2.707,4.526,3.232a8.429,8.429,0,0,0,6.995,3.914A8.853,8.853,0,0,0,37.023,33.8a2.422,2.422,0,0,0,0-4.817Zm-1.044.393a3.6,3.6,0,0,1-3.639-2.77,4.013,4.013,0,0,0,1.169-1.614A9.324,9.324,0,0,1,35.979,29.378Zm-7.312-6.35A7.024,7.024,0,0,1,32.9,24.479c-.492,2.383-5.479,4.345-11.457,4.48A7.706,7.706,0,0,1,28.666,23.028ZM17.871,33.7a1.6,1.6,0,0,1,.579-1.14A2.425,2.425,0,0,0,20.311,33.8a9.9,9.9,0,0,0,.859,2.284C19.026,35.563,17.871,34.754,17.871,33.7Zm18.893-.975a.44.44,0,0,1-.044-.005l-.578-.057-.094.486a7.811,7.811,0,0,1-7.383,6.609,7.2,7.2,0,0,1-5.438-2.57,39.725,39.725,0,0,0,4.163.287,1.328,1.328,0,1,0,.009-.726,36.261,36.261,0,0,1-4.8-.382,8.929,8.929,0,0,1-1.484-4.974,9.23,9.23,0,0,1,.158-1.706c4.44-.068,8.239-1.069,10.421-2.577a4.641,4.641,0,0,0,4.449,3.013h0l.576-.057.043-.005a1.333,1.333,0,0,1,0,2.665Z",
    transform: "translate(-17.145 -21.938)",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(8.223 8.555)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 0.9,
    cy: 0.9,
    r: 0.9,
    transform: "translate(13.02 8.555)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIco);
export default __webpack_public_path__ + "static/media/call-ico.7f6e052f3dafb577649ce06ac9509fe5.svg";
export { ForwardRef as ReactComponent };